export const AuthPrefix = "/auth";

export const HomeURLPath = "/";
export const CryptoOnboardingURLPath = "/onboarding";
export const DashboardURLPath = "/dashboard";
export const OpportunityPath = "/opportunities";
export const AccountPath = "/account";
export const LoginPath = "/auth/login";
export const WalletURL = "/wallet";
